<template>
    <div class="split-text">
        <div class="white_block">
            <div class="white_block_container flex">
                <div class="right_part">
                    <div
                        class="content"
                        v-html="isRtl ? value.rightText : value.leftText"
                    />
                </div>

                <div class="left_part">
                    <div
                        class="content"
                        v-html="isRtl ? value.leftText : value.rightText"
                    />
                </div>
            </div>
        </div>

        <div class="list_custom_category">
            <div class="list_title">
                {{
                    $t('articles.updatedAt', {
                        date: updatedAt
                    })
                }}
            </div>

            <div class="custom_categories" v-html="value.bottomText" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: true
        },

        article: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters(['isRtl']),

        updatedAt() {
            return this.$dayjs(this.value.updatedAt)
                .locale(this.$i18n.locale)
                .format('MMMM YYYY');
        }
    }
};
</script>
